import axios from "axios";
import { generateNewToken, isTokenExpired, oktaAuth } from "../okta/AuthService";

const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

const apiClient = axios.create({
    baseURL: apiBaseURL
});

apiClient.interceptors.request.use(
    async (config: any) => {
        if (config.url === '/user/register/partner') {
            return config;
        }
        const tokenObj: any = await oktaAuth?.tokenManager?.get('accessToken');
        let token = tokenObj?.accessToken;
        if (isTokenExpired(token)) {
            console.log("Token expired, generating new token")
            token = await generateNewToken();
        }
        config.headers.Authorization = `Bearer ${token}`;
        return { ...config, signal: config?.signal };
    },
    (error) => {
        return Promise.reject(error);
    }
)

export default apiClient;